import React, { useState } from 'react'
import { useEffect } from 'react'
import { APP_SOCKET_URL } from '../app/components/MConfig';
import { convertStringToBase64, isAnObject } from '../util';
export const WebsockStart = force => {
  const [iniciado, setIniciado] = useState(false);
  let webSocket;
  const reconnectInterval = 5000;
  let messageQueue = [];
  window.sockmessageQueue = messageQueue;

  async function connectWebSocket() {
      return new Promise((resolve, reject) => {
        
          webSocket = new WebSocket(APP_SOCKET_URL);
          window.sock = webSocket;
  
  
          webSocket.onopen = function() {
            if(window.log) console.log("Conectado ao WebSocket");

              var obj = JSON.parse(window.localStorage?.cnf);
              var objSend = JSON.stringify({ token: obj.token });

              if (webSocket && webSocket.readyState === WebSocket.OPEN) {
               
                while (messageQueue.length > 0) {
                  webSocket.send(messageQueue.shift());
                }
                
                webSocket.send(objSend);
            } else {
                
                messageQueue.push(objSend);
            }
              
              resolve();
          };
  
          webSocket.onerror = function(error) {
            if(window.log) console.error("Erro no WebSocket:", error);

              reject(error);
          };
  
          webSocket.onclose = function(event) {
              if(window.log) console.log("Conexão encerrada:", event.reason);
              attemptReconnect();
          };
  
          webSocket.onmessage = function(event) {
            if(window.log) console.log("Mensagem recebida via socket");
              var obj = JSON.parse(event.data);
              if (Array.isArray(obj)) {
                if(window.log)console.warn(obj);
                document.getElementById('msgexibidor').mensagem(obj);
              }
          };
      });
  }

  async function attemptReconnect() {
    setTimeout(function () {
      if(window.log)console.log("Tentando reconectar...");        
      iniciarConexao(); 
    }, reconnectInterval);
  }
  
  async function iniciarConexao() {
      try {
          await connectWebSocket();
          if(window.log)console.log("Conexão WebSocket estabelecida com sucesso!");
      } catch (error) {
        if(window.log)console.error("Erro ao estabelecer a conexão WebSocket:", error);
      }
  }

  window.sockReconnect = iniciarConexao;
  
    useEffect(() => {
      if (iniciado) return;
        iniciarConexao();      
        setIniciado(true);
    }, [])


  return <></>

}



export const enviarMensagemServidor = (mensagemEnviar,tipo) =>{    
  if(isAnObject(mensagemEnviar)) mensagemEnviar = JSON.stringify(mensagemEnviar);
  var token = window.cnf.token;
  var premsg = { mensagem : convertStringToBase64(mensagemEnviar) , token ,tipo}
  var msg = JSON.stringify(premsg);    
  if(window.log)console.log("MSG:" + msg);
  try{
      window.sock.send(msg);
  }catch{      
      window.sockmessageQueue.push(msg);     
  }
}